import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen grain">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="text-xs uppercase tracking-widest text-zinc-500 hover:text-white inline-flex items-center gap-1 mb-8">
          <ArrowLeft className="w-3 h-3" /> Back
        </Link>
        <div className="text-[10px] tracking-[0.3em] uppercase text-fuchsia-400 font-semibold">Xhat</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Terms of Service</h1>
        <p className="text-xs text-zinc-500 mt-2">Last updated: February 2026</p>

        <div className="mt-10 text-zinc-300 leading-relaxed space-y-6 max-w-none">
          <Section title="1. Who can use Xhat">
            You must be at least 18 years old. By using Xhat you confirm you meet this requirement.
          </Section>

          <Section title="2. Your content">
            You own what you post. By posting, you grant us a non-exclusive license to store and display your messages to other users of the same room. Messages in mini rooms are visible only to the room&apos;s members.
          </Section>

          <Section title="3. Community rules — zero tolerance">
            <ul className="list-disc pl-6 space-y-2">
              <li>No hate speech, slurs, or harassment based on sexuality, gender identity, race, religion, ability, or nationality.</li>
              <li>No threats, stalking, doxxing, or non-consensual sharing of private information.</li>
              <li>No sexual content involving minors. Ever. Accounts will be terminated and reported.</li>
              <li>No spam, scams, or impersonation.</li>
              <li>No unsolicited nudity in public rooms.</li>
            </ul>
            Violating any of these may result in message removal, suspension, or permanent ban without notice.
          </Section>

          <Section title="4. Reporting & blocking">
            Every message has a Report and Block option. Block removes someone&apos;s content from your view. Reports go directly to our moderation queue.
          </Section>

          <Section title="5. Video calls">
            Video calls are peer-to-peer between participants. We do not record, host, or store video or audio. You are responsible for the content you transmit.
          </Section>

          <Section title="6. Termination">
            We may suspend or terminate any account that breaks these terms, at our sole discretion.
          </Section>

          <Section title="7. No warranty">
            Xhat is provided &ldquo;as is&rdquo; without warranty of any kind. We do our best, but we can&apos;t guarantee uptime or that every user will behave.
          </Section>

          <Section title="8. Changes">
            We may update these terms. Continued use of Xhat after changes means you accept the new terms.
          </Section>

          <Section title="9. Contact">
            Questions? Email <a href="mailto:keandreleams@gmail.com" className="text-fuchsia-400 hover:text-fuchsia-300">keandreleams@gmail.com</a>.
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold tracking-tight text-white mb-3">{title}</h2>
      <div>{children}</div>
    </div>
  );
}
